document.addEventListener("DOMContentLoaded", () => {
  const startTicker = () => {
    const sections = document.querySelectorAll(".section-logo-list");

    sections.forEach(section => {
      const ticker = section.querySelector(".brands-items");
      if (!ticker) return;

      if (section.classList.contains("slider_started")) return;
      section.classList.add("slider_started");

      ticker.innerHTML += ticker.innerHTML;

      const logoList = section.querySelector(".logo-list");
      const speedSetting = Number(logoList && logoList.dataset.brandsSpeed) || 5;
      const duration = speedSetting * 10;
      const halfWidth = ticker.scrollWidth / 2;

      if (!halfWidth) return;

      let offset = 0;
      let lastTimestamp = null;
      let paused = false;

      ticker.addEventListener("mouseenter", () => (paused = true));
      ticker.addEventListener("mouseleave", () => (paused = false));

      const step = timestamp => {
        if (lastTimestamp !== null && !paused) {
          const pxPerSecond = halfWidth / duration;
          offset = (offset + ((timestamp - lastTimestamp) / 1000) * pxPerSecond) % halfWidth;
          ticker.style.transform = `translateX(-${offset}px)`;
        }
        lastTimestamp = timestamp;
        requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    });
  };

  startTicker();

  document.addEventListener("shopify:section:load", () => startTicker());
});
